import { Controller } from 'stimulus';

export default class extends Controller {
  onMove(event) {
    this.#highlightHoveredSwatch(event.detail.target);
  }

  onDrop(event) {
    const e = event.detail;

    if (document.querySelectorAll('.item--hovered-swatch').length) {
      window.ed._shared.recolorSwatch(e);
    } else {
      window.ed._shared.addItem({ e, selectItem: true, updateSingleItemZoomRatio: true });
    }
  }

  #highlightHoveredSwatch(target) {
    const positionOfCanvas = document.querySelector('.board-container').getBoundingClientRect();
    const centerX =
      target.offsetWidth / 2 + parseInt(target.style.left) + parseInt(positionOfCanvas.x);
    const centerY =
      target.offsetHeight / 2 + parseInt(target.style.top) + parseInt(positionOfCanvas.y);

    // get elements from position above
    const itemsUnderDraggable = document
      .elementsFromPoint(centerX, centerY)
      .filter((item) => item.classList.contains('item'));

    // remove all swatch hover classes
    document.querySelectorAll('.item').forEach((element) => {
      element.classList.remove('item--hovered-swatch', 'shadow-df-teal', 'shadow-[0_0_0_2px]');
    });

    // highlight hovered swatch
    if (
      target.dataset['moodboard-Drawers-Products-ThumbKindValue'] === 'swatch' && // make sure draggable element is swatch
      itemsUnderDraggable.length > 0 && // make sure at least one item is hovered
      itemsUnderDraggable[0].classList.contains('item--swatch') // meke sure top item is swatch
    ) {
      itemsUnderDraggable[0].classList.add(
        'item--hovered-swatch',
        'shadow-df-teal',
        'shadow-[0_0_0_2px]'
      );
    }
  }
}
